export default __webpack_public_path__ + "static/media/Image(2).a3706299.png";